import { productIsNew } from '../../utils/productNew.js';

/**
 * Badge «NOVO» na vitrine (created_at ≥ 15/09/2026 e < 21 dias).
 *
 * @param {{
 *   product: Record<string, unknown>|null|undefined,
 *   className?: string,
 *   overlay?: boolean,
 * }} props
 */
export function ProductNewHint({ product, className = '', overlay = true }) {
  if (!productIsNew(product)) return null;

  const pill = (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-emerald-200/90 bg-[#ecfdf5]/95 px-2.5 py-1 shadow-[0_2px_8px_rgba(16,185,129,0.22)] backdrop-blur-[1px] dark:border-emerald-900/50 dark:bg-emerald-950/85"
      title="Produto novo"
    >
      <span
        className="text-[10px] font-extrabold uppercase tracking-[0.12em] text-emerald-700 dark:text-emerald-400"
      >
        NOVO
      </span>
    </span>
  );

  if (!overlay) {
    return <div className={className.trim()}>{pill}</div>;
  }

  return (
    <div
      className={`pointer-events-none absolute left-2 top-2 z-[3] sm:left-2.5 sm:top-2.5 ${className}`.trim()}
      aria-label="Produto novo"
    >
      {pill}
    </div>
  );
}
